import { VariablesService } from './../../../../shared/services/variables/variables.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lead-success',
  templateUrl: './lead-success.component.html',
  styleUrls: ['./lead-success.component.scss']
})
export class LeadSuccessComponent implements OnInit {

  constructor(
    public variablesService: VariablesService
  ) { }

  ngOnInit() {
  }

}
